<!--
 * @Author: shijian.chen
 * @Date: 2021-11-09 16:52:12
 * @LastEditTime: 2023-02-27 17:55:28
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 领克广告
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/ftms/index.vue
-->
<template>
  <div id="qianbi">
    <div class="bg">
      <div>
        <img
          src="https://source.qunarzz.com/site/images/wns/20230227-shijianchen-1.jpg"
          alt=""
        />
        <img
          src="https://source.qunarzz.com/site/images/wns/20230227-shijianchen-2.jpg"
          alt=""
        />
        <img
          src="https://source.qunarzz.com/site/images/wns/20230227-shijianchen-3.jpg"
          alt=""
        />
        <img
          src="https://source.qunarzz.com/site/images/wns/20230227-shijianchen-4.jpg"
          alt=""
        />
        <img
          src="https://source.qunarzz.com/site/images/wns/20230227-shijianchen-5.jpg"
          alt=""
        />
        <img
          src="https://source.qunarzz.com/site/images/wns/20230227-shijianchen-6.jpg"
          alt=""
        />
        <img
          src="https://source.qunarzz.com/site/images/wns/20230227-shijianchen-7.jpg"
          alt=""
        />
        <img
          src="https://source.qunarzz.com/site/images/wns/20230227-shijianchen-8.jpg"
          alt=""
        />
        <img
          src="https://source.qunarzz.com/site/images/wns/20230227-shijianchen-9.jpg"
          alt=""
        />
        <img
          src="https://source.qunarzz.com/site/images/wns/20230227-shijianchen-10.jpg"
          alt=""
        />
      </div>
      <div class="btn-group">
        <a v-maidian="'btn1'"
          class="btn btn1"
          href="https://m.cdfgsanya.com/wap/index.html?targetEnterPage=productInfo&targetEnterParams=productId=710238_goodsId=803028"
        >
        </a>
        <a v-maidian="'btn2'"
          class="btn btn2"
          href="https://m.cdfgsanya.com/wap/index.html?targetEnterPage=productInfo&targetEnterParams=productId=405240_goodsId=529412"
        >
        </a>
        <a v-maidian="'btn3'"
          class="btn btn3"
          href="https://m.cdfgsanya.com/wap/index.html#/tabs/index/productInfo?productId=669164&goodsId=766111"
        >
        </a>
        <a v-maidian="'btn4'"
          class="btn btn4"
          href="https://lancome.asiatraveldutyfree.com/SuperSerum-popup/"
        >
        </a>
        <a v-maidian="'btn5'"
          class="btn btn5"
          href="https://m.cdfgsanya.com/wap/index.html#/tabs/index/productInfo?productId=648068&goodsId=750583"
        >
        </a>
        <a v-maidian="'btn6'"
          class="btn btn6"
          href="https://m.cdfgsanya.com/wap/index.html#/tabs/index/productInfo?productId=669164&goodsId=766111"
        >
        </a>
        <a v-maidian="'btn8'"
          class="btn btn8"
          href="https://m.cdfgsanya.com/wap/index.html#/tabs/index/productInfo?productId=348754&goodsId=523381"
        >
        </a>
        <a v-maidian="'btn7'"
          class="btn btn7"
          href="https://m.cdfgsanya.com/wap/index.html#/tabs/index/productInfo?productId=437460&goodsId=561469"
        >
        </a>
        <a v-maidian="'btn9'"
          class="btn btn9"
          href="https://m.cdfgsanya.com/wap/index.html#/tabs/index/productInfo?productId=505881&goodsId=626654"
        >
        </a>
        <a v-maidian="'btn10'"
          class="btn btn10"
          href="https://m.cdfgsanya.com/wap/index.html#/tabs/index/productInfo?productId=599811&goodsId=720617"
        >
        </a>
        <a v-maidian="'btn12'"
          class="btn btn12"
          href="https://m.cdfgsanya.com/wap/index.html#/tabs/index/productInfo?productId=403947&goodsId=528119"
        >
        </a>
        <a v-maidian="'btn11'"
          class="btn btn11"
          href="https://m.cdfgsanya.com/wap/index.html#/tabs/index/productInfo?productId=285808&goodsId=515792"
        >
        </a>
        <a v-maidian="'btn13'"
          class="btn btn13"
          href="https://m.cdfgsanya.com/wap/index.html#/tabs/index/productInfo?productId=426024&goodsId=550049"
        >
        </a>
        <a v-maidian="'btn14'"
          class="btn btn14"
          href="https://m.cdfgsanya.com/wap/index.html#/tabs/index/brandVisualIndex?brandId=248137"
        >
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang='less' scoped='true'>
img {
  display: block;
}
.btn {
  display: block;
  position: absolute;
  width: 92px;
  height: 26px;
  z-index:10;
  // background-color: #0f0;
}
.btn1 {
  left: 55px;
  top: 405px;
}
.btn2 {
  left: 124px;
  top: 1058px;
  width: 126px;
  height: 40px;
}
.btn3 {
  left: 124px;
  top: 1672px;
  width: 127px;
  height: 42px;
}
.btn4 {
  left: 217px;
  top: 2259px;
}
.btn5 {
  left: 25px;
  top: 2587px;
}
.btn6 {
  left: 260px;
  top: 2597px;
}
.btn7 {
  left: 245px;
  top: 2707px;
}
.btn8 {
  left: 50px;
  top: 2877px;
}
.btn9 {
  left: 45px;
  top: 3275px;
  width: 101px;
  height: 30px;
}
.btn10 {
  left: 230px;
  top: 3275px;
  width: 101px;
  height: 30px;
}
.btn11 {
  left: 230px;
  top: 3580px;
  width: 101px;
  height: 30px;
}
.btn12 {
  left: 45px;
  top: 3580px;
  width: 101px;
  height: 30px;
}
.btn13 {
  left: 138px;
  top: 3791px;
  width: 101px;
  height: 30px;
}
.btn14 {
  left: 138px;
  top: 3857px;
  width: 101px;
  height: 30px;
}
.btn-group {
  position: absolute;
  width: 100%;
  top: 334px;
}
.bg {
  height: 4400px;
  overflow: hidden;
  img {
    position: relative;
  }
  img:nth-child(2) {
    position: relative;
    top: -1px;
  }
  img:nth-child(3) {
    position: relative;
    top: -2px;
  }
  img:nth-child(4) {
    position: relative;
    top: -3px;
  }
  img:nth-child(5) {
    position: relative;
    top: -4px;
  }
  img:nth-child(6) {
    position: relative;
    top: -5px;
  }
  img:nth-child(7) {
    position: relative;
    top: -6px;
  }
  img:nth-child(8) {
    position: relative;
    top: -7px;
  }
  img:nth-child(9) {
    position: relative;
    top: -8px;
  }
  img:nth-child(10) {
    position: relative;
    top: -9px;
  }
}
</style>